import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

type Link = { path: string; label: string; componentRef: React.MutableRefObject<HTMLDivElement | null> }

export const useScrollIntoView = (link: Link) => {
  const { hash } = useLocation()
  useEffect(() => {
    if (hash === link.path && link.componentRef.current) {
      link.componentRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [hash, link])
}
